<template>
	<card class="reSearchCardClient">
		
		<div class="card-user">
			<div class="left_part">
				<div class="avatarBlk author">
					<div class="photo"><img class="avatar" :src="strPhotoSrc" /></div>
					<div class="clientId">
						<p>ID {{objClient.id}}</p>
					</div>
					<div>
						<span class="badge badge-pill badge-success" v-if="objClient.client_type == 1">ФИЗ ЛИЦО</span>
						<span class="badge badge-pill badge-primary" v-else>ЮР ЛИЦО</span>
					</div>
					<base-button @click="OpenCard(objClient.id)" type="primary" simple>Посмотреть</base-button>
				</div>
				<div class="fioContactsBlk">
					<div class="fioBlk mb-3">
						<h4 class="title">ФИО</h4>
						<div class="description"><p>{{objClient.fio}}</p></div>
					</div>
					<div class="fioBlk mb-3" v-if="objClient.descr">
						<h4 class="title">Примечание</h4>
						<div class="description"><p>{{objClient.descr}}</p></div>
					</div>
					<div class="contactsBlk mb-3" v-show="!$GVO.isEmpty(objClient.contacts)">
						<h4 class="title">Контакты</h4>
						<template v-for="(dopContact, dc_index) in objClient.contacts">
							<p class="description" :key="dc_index" v-if="dopContact.contact_group!='social' && typeof dopContact !='undefined'">
								<span class="d-inline-block mr-2">{{strContactType(dopContact)}}</span> 
								<a :href="hrefContact(dopContact)" class="d-inline-block mr-1" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
									<i v-if="dopContact.contact_group=='email'" class="d-inline-block tim-icons icon-email-85"></i>
									<i v-if="dopContact.contact_group=='phone'" class="d-inline-block tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)"></i>
									<i v-if="dopContact.contact_group=='web'" class="d-inline-block tim-icons icon-link-72"></i>
									<i v-if="dopContact.contact_group=='messanger'" class="d-inline-block tim-icons icon-send"></i>
									<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objClient.id)">{{dopContact.contact_value}}</span>
									<span v-else>{{dopContact.contact_value}}</span>
								</a>
							</p>
						</template>
					</div>
					<template v-if="objClient.address.length>0">
						<div class="fioBlk" v-for="(objAddr, addr_index) in objClient.address" :key="addr_index">
							<h4 class="title">Адрес</h4> 
							<div class="description d-flex flex-wrap">
								<p>
								<span  v-if="objAddr.inputText!=''">{{objAddr.inputText}}</span>
								<span v-else>{{objAddr.text_addr}}</span>
								
								<span v-if="objAddr.flat_num!=''">, кв.{{objAddr.flat_num}}</span>
								</p>
							</div> 
						</div>
					</template>
				</div>
			</div>
			<div class="right_part" :class="[(isActive && objClient.SERVICES.length>1) ? 'expand-hidden' : 'expand-visible']">
				<!--div class="uslugaBlk">
					<h4 class="title">Оказываемая услуга</h4>
					<template v-if="objClient.SERVICES.length>0">
						<div class="description service-row" v-for="service in objClient.SERVICES" :key="service.BP_NAME+' '+service.id">
							<p>{{service.BP_NAME}}</p>
							<p class="agent-name">{{service.agent_name}}</p>
						</div>
					</template>
				</div-->
				<!--div class="stageBlk">
					<h4 class="title">Этап</h4>
					<template v-if="objClient.SERVICES.length>0">
						<div class="description" v-for="service in objClient.SERVICES" :key="service.STAGE_NAME+' '+service.id"><p>{{service.STAGE_NAME}}</p></div>
					</template>
				</div-->

				<div class="uslugaBlk col-md-7 col-sm-12 px-0" >
					<h4 class="title">Оказываемая услуга</h4> 
					<template v-if="objClient.SERVICES.length>0">
						<div class="service-col mb-3 ml-2" v-for="service in objClient.SERVICES" :key="service.BP_NAME+' '+service.id" >
							<p :class="[{'text-warning':service.STATUS == 'На контроле'}, {'text-danger':service.STATUS == 'В архиве'}, {'text-primary':service.STATUS == 'В работе'}, {'text-success':service.STATUS == 'Сделка закрыта'}]">								
								<span class="text-warning mr-2" v-if="service.STATUS == 'На контроле'">На контроле: </span>
								<span class="text-danger mr-2" v-if="service.STATUS == 'В архиве'">Отказ: </span>
								<span class="text-primary mr-2" v-if="service.STATUS == 'В работе'">В работе: </span>
								<span class="text-success mr-2" v-if="service.STATUS == 'Сделка закрыта'">Сделка: </span>
								{{service.BP_NAME}} {{service.BP_EXT_NAME}} 
							</p> 
							<div class="d-flex" v-if="service.lead_id !=''" ><span class="ml-0 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">из лида</span></div>
							<div class="service-row">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Этап</p>
								<p>{{service.STAGE_NAME}}</p>
							</div>
							<div class="service-row" v-if="typeof service.adsSourceName != 'undefined' && service.adsSourceName != '' && service.adsSourceName != null">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Источник лида</p>
								<p>{{service.adsSourceName}}</p>
							</div>
							<div class="service-row">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Ответственный</p>
								<p>{{service.agent_name}}</p>
							</div>
							<div class="row mx-0">			
								<div class="d-flex mr-4 align-items-baseline">
									<p class="mb-0 mr-2 font-weight-bold">Создано</p>
									<p class="mb-0">{{$GVO.convertDateTimeFromMysql(service.InsertTime)}}</p>
								</div>
								<div class="d-flex mr-4 align-items-baseline">
									<p class="mb-0 mr-2 font-weight-bold">Посл. изменение</p>
									<p class="mb-0">{{$GVO.convertDateTimeFromMysql(service.UpdateTime)}}</p>
								</div>
								<div v-if="service.STATUS != 'Сделка закрыта'" class="d-flex mr-4 align-items-baseline">
									<p class="mb-0 mr-2 font-weight-bold">Дней в работе</p>
									<p class="mb-0">{{daysInWork(service)}}</p>
								</div>
							</div>
						</div>

					</template>
					<!-- <div class="openbtn-container position-btn" :class="[isActive ? 'position-btn-shadow' : '']" v-if="objClient.SERVICES.length>1">
						<button class="expandBtn" @click="toggleText()">{{expandText.text}}</button>
					</div> -->
				</div>

				<div class="taskBlk col-md-5 col-sm-12 px-0" v-if="objClient.SERVICES.length>0">
					<h4 class="title">Задачи</h4>
					<template v-for="service in objClient.SERVICES">
						<div class="description" 
							v-if="service.BP_TASKS.length>0"
							:key="service.id"
							>
							<div v-for="task in service.BP_TASKS" :key="task.id">
								<router-link :class="[{'text-danger':task.overdue == '1' && task.STATUS!='Готово'}]" :to="'/data/tasks/id/'+task.id">
									<i v-if="task.overdue == '1' && task.STATUS!='Готово'" class="tim-icons text-danger icon-alert-circle-exc"></i>
									{{task.BP_TASK_NAME}}  
								</router-link>
								<span v-if="task.READONLY =='1' && task.overdue != '1' && task.STATUS!='Готово' && task.editable!=0">{{$GVO.convertDateTimeFromMysql(task.STARTDATE)}}</span>
							</div>
						</div>
					</template>
				</div>
				<div class="openbtn-container position-btn" :class="[isActive ? 'position-btn-shadow' : '']" v-if="objClient.SERVICES.length>1">
						<button class="expandBtn" @click="toggleText()">{{expandText.text}}</button>
					</div>
			</div>
		</div>
	</card>
</template>

<script>
	export default {
		name: 'ReSearchCardClient',
		components: {

		},
		props: {
			objClient: Object,
		},
		data () {
			return {
				ver: 1,
				expandText: {
					text: "Показать полностью"
				},
				isActive: true,
			}
		},
		computed: {
			strPhotoSrc(){
				return this.$GVO.isEmpty(this.objClient.photo)?'/img/placeholder.jpg':this.objClient.photo;
			},
		},
		methods: {
			/*
			hrefContact(contactType,contactText){
				//console.log(contactType);
				switch (contactType) {
					case 'email':
						return 'mailto:'+contactText;
						break;
					case 'WhatsApp':
						return 'https://wa.me/'+contactText;
						break;
					case 'telegram':
						return 'tg://resolve?domain='+contactText;
						break;
					case 'viber':
						return 'viber://add?number='+contactText;
						break;
					case 'skype':
						return 'skype:'+contactText+'?call';
						break;
					default:
						return '#';
						break;
				}
				return '#';
			},*/
			hrefContact(dopContact){
				//console.log(contactType);
				let strHref = '#';
				switch (dopContact.contact_type) {
					case '11'://email
						strHref = 'mailto:'+dopContact.contact_value;
						break;
					case '41'://watsapp
						strHref = 'whatsapp://send?phone='+dopContact.contact_value;
						break;
					case '40'://telegram
						strHref = 'tg://resolve?domain='+dopContact.contact_value;
						break;
					case '42'://viber
						strHref = 'viber://chat?number='+dopContact.contact_value;
						break;
					case '43'://skype
						strHref = 'skype:'+dopContact.contact_value+'?call';
						break;
					case '21'://web
						strHref = dopContact.contact_value;
						break;
				}
				return strHref;
			},
			OpenCard: function(client_id){
				this.$router.push({path: '/data/clients/id/'+client_id});
			},
			strContactType: function(objContact){
				if(typeof this.$GVO.cats.CONTACTS_TYPES != 'undefined'&& this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group] && typeof this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group].types != 'undefined'){
					return this.$GVO.cats.CONTACTS_TYPES[objContact.contact_group].types[objContact.contact_type];
				}
				return '';
			},
			Call(strPhone,obj_type,obj_id){
				this.$GVO.Call(strPhone,obj_type,obj_id);
			},		
			daysInWork(obj){
				let daysInWorkTotal = obj.InsertTime.replace(' ', 'T') +'Z';			
				let d = new Date();
				let newDateFormated = d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2) +'Z';
				let t = Date.parse(newDateFormated) - Date.parse(daysInWorkTotal);

				// let t = Date.parse(new Date()) -  Date.parse(obj.InsertTime);	
				let minutes = Math.floor((t / 1000 / 60) % 60);
				let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
				let days = Math.floor(t / (1000 * 60 * 60 * 24));	
				//console.log(obj.InsertTime);
				return `${days} д ${hours} ч ${minutes} м`;
			},	
			toggleText(event) {
				this.isActive = !this.isActive;
				if (this.isActive) {
					this.expandText.text = "Показать всё";
				} else this.expandText.text = "Скрыть";
			},
			
		},
	}
</script>
<style scoped>
	.reSearchCardClient {border: 1px solid #9e77f3;  box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important;}
	.reSearchCardClient .badge {font-size: 0.7rem;}
	
	.reSearchCardClient .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.reSearchCardClient .card-user .author{margin-top: 0px;}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	.card-user .left_part{max-width:490px;}
	.card-user .right_part{justify-content: space-between; position: relative;}
	.card-user .left_part > *, .card-user .right_part > *{display: inline-block; vertical-align: top; margin-right: 15px;}
	/*.card-user .right_part > *{width: calc(100% / 3); min-width: 180px;}*/

	.avatarBlk{min-width: 180px;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}

	.fioContactsBlk{
		display: flex;
	}
	.reSearchCardClient .description {word-break: break-word;}
	p.description{font-size: 1em;}
	p.description a > i{ margin-right: 5px;}

	.btn-icon .fab{
		position: absolute;
		font-size: 1em;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-12px, -12px);
		transform: translate(-12px, -12px);
		line-height: 1.5626rem;
		width: 24px;
	}
	.service-col {display: flex; flex-direction: column;}
	.service-row {display: flex; flex-wrap: wrap;}
	.agent-name, .service-title {font-weight: bold; padding-left: 8px;}
	/* .marker::before {
		content: "\20DD";
		color: #01B0E0;
		padding-right: 18px;
		font-size: 8px;
		font-weight: normal;
	} */
	.marker::before {
		content: "";
		display: inline-block;
		margin-right: 10px;
		border: 1px solid #01B0E0;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		font-size: 12px;
		font-weight: normal;
	}
	.card-warning {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #ff8d72!important;}
	.card-danger {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #f84e54!important;}
	.uslugaBlk, .taskBlk {
		/* height: 420px;
		padding-bottom: 20px; */
		position: relative;
	}
	.expand-hidden {
		max-height: 26rem;
		/* max-height: 424px; */
		overflow: hidden;
		padding-bottom: 30px;
	}
	.expand-visible {
		height: auto;
	}
	.position-btn {
		position: absolute;
		bottom: -5px;
		z-index: 2;
		background-color: #27293d;
		width: 100%;
		padding-top: 3px;
	}
	.position-btn-shadow { box-shadow: 0px 3px 15px 0px rgba(123, 123, 123, 0.7) !important;}

	.white-content .card:not(.card-white) .position-btn{
		background-color: #fff;
	}
	.expandBtn {
		background-color: transparent;
		border: none;
		outline: none;
		color: #9e77f3;
		
	}
	.expandBtn:hover {
		color: #01b0e0;
	}
	@media (max-width: 860px){
		.reSearchCardClient .card-user{
			display: block;
		}
		.card-user .left_part, .card-user .right_part{display: block;}	
		.uslugaBlk, .stageBlk, .taskBlk {margin-top: 20px;}
		.fioContactsBlk {margin-top: 10px;}
		.card-user .author {margin: 0px auto; display: block;}
		.card-user .title h4 {margin-bottom: 5px;}
		.card-user .left_part {max-width: 100%;}		
	}
	@media (max-width: 600px){
		.card-user .right_part > *{display: block; width: 100%;}
	}
</style>
